/**
 * Handles all functionality related to domain navigation
 *
 * A11Y requirements: {@link  https://www.w3.org/TR/wai-aria-practices/examples/disclosure/disclosure-navigation.html}
 */

import DomElements from "./domElements.js";
const { $navDomainLinks: $links } = DomElements;

/**
 * Initialize nav domain functionality
 */
export default function initNavDomain() {
  initKeyboardSupport();
}

/**
 * Keyboard support (A11Y)
 */
const initKeyboardSupport = () => {
  if ($links?.length) {
    $links.forEach(($link, i) => {
      $link.addEventListener("keyup", (event) => {
        switch (event.code) {
          case "ArrowDown":
          case "ArrowRight":
            i + 1 in $links && $links[i + 1].focus();
            break;
          case "ArrowUp":
          case "ArrowLeft":
            i - 1 in $links && $links[i - 1].focus();
            break;
          case "Home":
            $links[0].focus();
            break;
          case "End":
            $links[$links.length - 1].focus();
            break;
        }
      });
    });
  }
};
